import { z } from 'zod';
import { OpoRoleEnum } from '@/api/apis/customer';
import { TMDXFile } from '@/api/apis/files';
import { CONTACT_FORM_DEFAULT_VALUES, contactSchema, opoContactSchema } from '../MainContactForm';
import { addCustomIssue, validateInviteAsUserFields } from '../shared/invite-validation';

export type OpoContactMembershipForm = {
  opoOrganizationId: string;
  roles: OpoRoleEnum[];
};

export type CreateOpoContactFormValues = {
  parentId: string;
  parentName: string;
  firstName?: string;
  lastName?: string;
  photo?: TMDXFile;
  photoPath?: string | null;
  email?: string | null;
  primaryPhone?: string;
  secondaryPhone?: string;
  inviteAsUser: boolean;
  memberships: OpoContactMembershipForm[];
};

export const DEFAULT_CONTACT_VALUES: CreateOpoContactFormValues = {
  parentId: '',
  parentName: '',
  inviteAsUser: false,
  memberships: [],
  ...CONTACT_FORM_DEFAULT_VALUES,
};

export const contactLocationSchema = z.object({
  parentId: z.string().min(1, 'Select Contact location'),
  parentName: z.string(),
});

export const contactFormSchema = contactLocationSchema.extend(contactSchema.shape);

const opoContactMembershipsSchema = z.array(
  z.object({
    opoOrganizationId: z.string().min(1),
    roles: z.array(z.enum(OpoRoleEnum)),
  }),
);

export const opoContactFormSchema = contactLocationSchema
  .extend({
    ...opoContactSchema.shape,
    inviteAsUser: z.boolean(),
    memberships: opoContactMembershipsSchema,
  })
  .superRefine((data, ctx) => {
    if (!data.inviteAsUser) return;

    validateInviteAsUserFields(data, ctx);

    if (!data.memberships[0]?.roles?.length) {
      addCustomIssue(ctx, ['memberships', 0, 'roles'], 'Select at least one role');
    }
  });

export const editOpoContactFormSchema = opoContactFormSchema;
